import { Injectable } from '@angular/core';
import { forkJoin, take } from 'rxjs';
import { IpTrackerService } from '../data/ip-tracker.service';
import { StartUpConfigUiService } from './start-up-config-ui.service';

@Injectable({
  providedIn: 'root'
})
export class TrackingUiService {
  constructor(
    private startUpConfigUiService: StartUpConfigUiService,
    private ipTrackerService: IpTrackerService
  ) {}

  public initIpTracking(): void {
    forkJoin(this.startUpConfigUiService.initialConfig$.pipe(take(1)), this.startUpConfigUiService.deferredConfig$.pipe(take(1)), this.startUpConfigUiService.sessionInfo$.pipe(take(1))).subscribe(
      ([, defferedConfig, sessionInfo]) => {
        // for performance purpose, loading additional scripts is delayed.
        setTimeout(() => {
          this.ipTrackerService.initIPTracker(defferedConfig.ipTrackerSettings, sessionInfo.sessionTrackingId);
        }, 2000);
      }
    );
  }
}
